import React, {
    useContext,
    useEffect,
    useState,
} from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import AppContext from "./AppContext"
import useAuth from './useAuth'

const getUserRoleAuthStatus = (pathname, user, routes) => {
    
    const matched = routes.find((r) => r.path === pathname);
    const authenticated = matched ? true : false
    return authenticated
  
};
// function getrole(){

//     if(user.role === null){return 'ADMIN'} else{return}
// }
const AuthGuard = ({ children }) => {
    const {
        isAuthenticated,
        user
    } = useAuth()

    const [previouseRoute, setPreviousRoute] = useState(null)
    const { pathname } = useLocation()

    const { routes } = useContext(AppContext);
    
    const isUserRoleAuthenticated = getUserRoleAuthStatus(pathname, user, routes);
    let authenticated = isAuthenticated && isUserRoleAuthenticated;

    // IF YOU NEED ROLE BASED AUTHENTICATION,
    // UNCOMMENT ABOVE TWO LINES, getUserRoleAuthStatus METHOD AND user VARIABLE
    // AND COMMENT OUT BELOW LINE
    // let authenticated = isAuthenticated

    useEffect(() => {
        if (previouseRoute !== null) setPreviousRoute(pathname)
    }, [pathname, previouseRoute])

    if (authenticated) return <>{children}</>

    else {
        return (
            <Redirect
                to={{
                    pathname: '/Login',
                    state: { redirectUrl: previouseRoute },
                }}
            />
        )
    }
}

export default React.memo(AuthGuard)
